(function() {

  angular
  .module('meanApp')
  .factory('Measure', Measure);

  Measure.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Measure ($http, httpAuth, $rootScope, Model) {
    var Measure = function (userData) {
        Model.apply(this, arguments);
    };

    Measure.APIPath = 'measures';
    Measure.prototype = {
        getAPIPath: function() {
            return Measure.APIPath;
        }
    };
    
    angular.extend(Measure.prototype, Model.prototype);

    return Measure;
  };

})();